import React, { useEffect, useState } from 'react';
import { useAppDispatch, useAppSelector } from 'app/hooks';
import { Select, Button } from 'antd';
import { getListEmailServer } from '../../onboard/onboardAction';
import { selectOnboard } from '../../onboard/onboardSlice';
import { useTranslation } from 'react-i18next';
import axiosClient from 'api/axiosClient';

const { Option } = Select;

interface SelectEmailServerToSendOffboardProps {
  onSend: (serverId: string) => void;
  loading?: boolean;
}

const SelectEmailServerToSendOffboard: React.FC<SelectEmailServerToSendOffboardProps> = ({
  onSend,
  loading,
}) => {
  const [listEmailServer, setListEmailServer] = useState<any>([]);
  const { t } = useTranslation(['onboard']);

  // Lấy danh sách email server khi component mount
  useEffect(() => {
    const getListEmailServerPublic = async () => {
      const response = await axiosClient.get(`/configurations/config-email-server-public`);
      if (response.data) {
        setListEmailServer(response.data.result);
      }
    };
    getListEmailServerPublic();
  }, []);

  // State lưu email server đã chọn
  const [selectedServer, setSelectedServer] = useState<string>('');

  // Cập nhật lại khi danh sách server thay đổi
  useEffect(() => {
    if (listEmailServer.length > 0) {
      setSelectedServer(listEmailServer[0].id);
    }
  }, [listEmailServer]);

  return (
    <div style={{ display: 'flex', gap: 8 }}>
      <Select
        value={selectedServer}
        onChange={setSelectedServer}
        style={{ minWidth: 200 }}
        placeholder="Chọn email server"
      >
        {listEmailServer.map((server: any) => (
          <Option key={server.id} value={server.id}>
            {server.mailNameFrom}
          </Option>
        ))}
      </Select>
      <Button
        type="primary"
        onClick={() => onSend(selectedServer)}
        disabled={!selectedServer}
        loading={loading}
      >
        {t('send')}
      </Button>
    </div>
  );
};

export default SelectEmailServerToSendOffboard;
